var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIphoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 1H8.625C7.245 1 6.125 2.12 6.125 3.5V20.5C6.125 21.88 7.245 23 8.625 23H16.625C18.005 23 19.125 21.88 19.125 20.5V3.5C19.125 2.12 18.005 1 16.625 1ZM12.625 22C11.795 22 11.125 21.33 11.125 20.5C11.125 19.67 11.795 19 12.625 19C13.455 19 14.125 19.67 14.125 20.5C14.125 21.33 13.455 22 12.625 22ZM17.125 18H8.125V4H17.125V18Z",
    fill: "#AFBAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIphoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIphoneIcon.0ed7660d2337f6f8e509e10e3d79d074.svg";
export { ForwardRef as ReactComponent };